import React, { Component } from "react";
import { Accordion, Grid, Image } from 'semantic-ui-react';
import { MemoryRouter as Router, Route } from "react-router-dom";
import PanelHeader from "./components/PanelHeader/index";
import AttachmentItem from "./components/AttachmentItem/index";

var _ = require('lodash');

var defaultSection = document.getElementById("att-tasks").getAttribute("data-default-section");
var jsonRoute = document.getElementById("att-tasks").getAttribute("data-att-tasks-component");

function isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}

class AttTasks extends Component {

    constructor(props) {
        super(props)
        this.state = { sectionMarkup: null }
        this.panel1 = React.createRef();
    }

    componentDidMount() {
        fetch(jsonRoute)
            .then(res => res.json())
            .then(data => {
                var sectionMarkup = [];  //Contains title of each main panel section
                    
                    if(data){
                        _.forEach(data,(section, i) => {
                            if (!isObject(section))
                                return;
    
    
                            var key = section.sectionType;
                            var panels = [];  //Contains title of each panel
    
                            //Panel Header Stuff
                            var panelClass = "panel-" + key.toLowerCase().replace(" ", "");
                            var description = section.sectionDesc;
                            var accent = section.sectionAcc;
                            var sectionLabel = section.sectionLabel;
                            var sectionTitle = section.sectionTitle;
                            var sectionImgURL = section.sectionImgURL;
                            var sectionVidID = section.sectionVidID;
                            var cta = section.sectionCta;
                            // var ctaURL = section.sectionCtaUrl; 
                            var basicPackage = section.basicPackage || false;
                            var premiumPackage = section.premiumPackage || false;
                            var buyThisBasicPackage = section.buyThisPackage || "Buy This Package";
                            var buyThisPremiumPackage = section.buyThisPackage || "Buy This Package";

                        
                            console.log("basicPackage:", basicPackage);
                            console.log("premiumPackage:", premiumPackage);
    
                            sectionMarkup.push(
                                <section>
                                    <Route
                                        path="/"//:panel?"
                                        component={props => {
                                            const params = new URLSearchParams(document.location.search); 
                                            const panel = params.get('panel');
                                            // console.log("panel: "+ panel);
                                            // console.log("panels: "+ panels);

                                            // console.log("sectionLabel: "+ sectionLabel.toLowerCase().replace(/\s/g, ""));

                                            //debugger;
                                        
                                            if (panel === sectionLabel.toLowerCase().replace(/\s/g, "")) {
                                                return (
                                                    <PanelHeader 
                                                        panels={panels} 
                                                        basicPanels={basicPackage} 
                                                        premiumPanels={premiumPackage} 
                                                        state={true} 
                                                        className={panelClass} 
                                                        label={sectionLabel} 
                                                        title={sectionTitle} 
                                                        type={key} 
                                                        desc={description} 
                                                        accent={accent} 
                                                        imgURL={sectionImgURL} 
                                                        vidID={sectionVidID} 
                                                        cta={cta} 
                                                        // ctaURL={ctaURL} 
                                                    ></PanelHeader>
                                                );
                                            } else {
                                                return (
                                                    <PanelHeader 
                                                    panels={panels} 
                                                    basicPanels={basicPackage} 
                                                    premiumPanels={premiumPackage} 
                                                    state={false} 
                                                    className={panelClass} 
                                                    label={sectionLabel} 
                                                    title={sectionTitle} 
                                                    type={key} 
                                                    desc={description} 
                                                    accent={accent} 
                                                    imgURL={sectionImgURL} 
                                                    vidID={sectionVidID} 
                                                    cta={cta} 
                                                    // ctaURL={ctaURL} 
                                                >
                                                        {/* <AttachmentItem title="D120 Loader + 1250 mm (49 in.) quick-change materials bucket" id="1470P" desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus mi ipsum, dapibus sit amet velit non, vulputate ullamcorper nunc." img="/img/fpo-img.png" />
                                                        <AttachmentItem title="RC2048 Rotary Cutter" id="0511XF" desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus mi ipsum, dapibus sit amet velit non, vulputate ullamcorper nunc." img="/img/fpo-img.png" />
                                                        <AttachmentItem title="120R Loader + 1350 mm (53 in.) quick-change materials bucket" id="1752P" desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus mi ipsum, dapibus sit amet velit non, vulputate ullamcorper nunc." img="/img/fpo-img.png" /> */}
                                                    </PanelHeader>
                                                );
                                            }
                                        }}
                                    />
                                </section>
                            );
    
                            // }
                        });
                    }
                    
                



                this.setState({ sectionMarkup: sectionMarkup });
            });

    }


    render() {
        if (this.state.sectionMarkup) {
            return <div>{this.state.sectionMarkup}</div>;
        }
        return <div>Loading...</div>;
    }
};

export default () => {
    return (
        <Router>
            <div>
                <AttTasks />
            </div>
        </Router>
    );
};


// WEBPACK FOOTER //
// ./src/App.js